import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSortGoal from 'webapp/models-custom/filter-sort/goal';
import type Goal from 'webapp/models-custom/goal';

export const viewSettingsNamePrefix = 'goalsTeamsViewSettings';
export const settingsNamePrefix = 'goalsTeamsFilterSettings'; // used to save filter preferences

export default class FilterSortGoalTeams extends FilterSortGoal {
	viewSettingsNamePrefix = viewSettingsNamePrefix;
	settingsNamePrefix = settingsNamePrefix;

	constructor(options: FilterSortSettings<Goal>) {
		super(options);

		this.createFilters();
	}

	createFilters(): void {
		const selectedFilters = this.readSavedSelectedFilters();

		this.createTimeframeFilter(selectedFilters);

		this.createFilter<number>({
			id: 7,
			label: 'Status',
			name: 'status',
			selected: selectedFilters[7] as number | undefined,
			isMultiSelect: true,
			getOptions: () => {
				return this.statusOptions;
			},
			filterFn: (item, selected) => {
				return selected.some(
					(selectedValue) => item.primaryDataModel?.status === selectedValue,
				);
			},
		});

		this.createFilter<number>({
			id: 3,
			label: 'Owned by',
			name: 'owner',
			selected: selectedFilters[3] as number | undefined,
			isMultiSelect: true,
			getOptions: () => {
				return this.ownerOptions;
			},
			filterFn: function (item, selected) {
				return selected.some((selectedValue) => {
					if (selectedValue === -1) {
						// exception: all others
						return !item.isOwnedByMe;
					} else {
						return item.ownerId === selectedValue;
					}
				});
			},
		});

		this.createFilter<string>({
			id: 10,
			label: 'Team',
			name: 'team',
			selected: selectedFilters[10] as string | undefined,
			isMultiSelect: true,
			getOptions: () => {
				return this.groupOptions;
			},
			filterFn: function (item, selected) {
				return selected.some((selectedValue) => {
					if (selectedValue === 'all') {
						return item;
					}

					return item.groupId === selectedValue;
				});
			},
		});
	}
}
